import { getDateNoTime } from '@assets/js/dateUtils';

export const tableProperties = [
  { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
  { label: '销售合同号', prop: 'scon_no', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '客户订单号', prop: 'customer_order_no', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '客户简称', prop: 'transaction_customer_name', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '客户货号', prop: 'prod_cust_no', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '我司货号', prop: 'prod_no', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '业务部门', prop: 'sales_department_name', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '外销员', prop: 'sales_staff_name', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  {
    label: '打样单号',
    prop: 'sampling_order_number',
    itemType: 'input',
    input: true,
    sortable: false,
    labelWidth: 120,
    subItem: { type: 'input', required: true, disabled: true }
  },
  { label: '更改号', prop: 'change_no', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '品名', prop: 'prod_name', itemType: 'input', input: true, sortable: false, labelWidth: 120 },
  { label: '订单数量', prop: 'prod_num', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '单位', prop: 'prod_unit', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '包装方式', prop: 'packaging_method', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  {
    label: '通知时间',
    prop: 'create_time',
    itemType: 'date',
    input: false,
    sortable: false,
    labelWidth: 120,
    formatter: val => getDateNoTime(val, true)
  },
  { label: '状态', prop: 'status', itemType: 'input', input: false, sortable: false, labelWidth: 120 },
  { label: '操作', prop: 'operation', itemType: 'input', input: false, sortable: false, labelWidth: 120 }
];
